
// pick relevant props for ActivityLog
export const pickBundleProps = (bundle) => {
  const { PlanName, Math, CarrierName, HealthPlanId, PlanType, MetalLevel, BundlePublicKey } = bundle
  const { WorkerPrice, TotalPrice } = Math ?? {}
  return { PlanName, WorkerPrice, TotalPrice, CarrierName, HealthPlanId, PlanType, MetalLevel, BundlePublicKey }
}
